import { Banner } from "react-native-paper";

import Icon from "@react-native-vector-icons/material-design-icons/static";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";

type Props = {
	visible?: boolean;
	duration?: number;
	action?: {
		label: string;
		onPress: () => void;
	};
	description?: string;
	severity?: unknown;
	icon?: string;
	callback?: () => void;
	title?: string;
	rightComponent?: React.ReactNode;
};

const AlertStandard = ({ visible, action, description, icon }: Props) => {
	const theme = useAppTheme();
	return (
		<Banner
			visible={visible!}
			actions={[
				{
					label: action?.label!,
					onPress: action?.onPress,
				},
			]}
			icon={() => (
				<Icon
					name={icon as IconType}
					size={24}
					color={theme.colors.onSurface}
				/>
			)}
		>
			{description}
		</Banner>
	);
};

export { AlertStandard };
